import styled from 'styled-components'
import {CloseButton} from '../button/close-button/close-button'
import {spacing} from '../../theme/spacing'

export const Modal = styled.div`
    background: white;
    position: relative;
    display: flex;
    flex: 1 1 0;
    flex-direction: column;
    min-height: 0;
    height: 100%;
    overflow: auto;
`

export const Dialog = styled.div`
    font-size: 16px;
    color: #333;
    min-width: 0;
`

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const ModalHeader = styled.div<{$dialogWidth?: number}>`
    position: sticky;
    top: 0;
    // NOTE: just to ensure it will be display on top of body (content)
    z-index: 1005;
    padding: ${spacing(2)} ${spacing(4)};
    background-color: #fff;
    border-bottom: 2px solid #e5e7eb;
    padding-bottom: ${spacing(1)};
    width: ${({$dialogWidth}) => ($dialogWidth ? `${String($dialogWidth)}px` : 'auto')};
`

export const LeftGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
`
export const RightGroup = styled.div`
    gap: 8px;
    position: relative;
    height: 100%;
    align-items: start;
`

export const ModalTitle = styled.h2`
    color: #374151;
    margin: 0 0 0 40px;
    padding: 0;
`

export const Title = styled.h2`
    margin: 0;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
`

export const Footer = styled.div`
    position: sticky;
    bottom: 0;
    // NOTE: just to ensure it will be display on top of body (content)
    z-index: 1005;
    background-color: white;
    text-align: right;
    padding-top: 15px;
`

export const ModalCloseButton = styled(CloseButton)`
    position: absolute;
    right: 0;
    padding: 10px;
`
